import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box, Container, Radio, RadioGroup, Typography, Grid,
  TextField, Button,
  InputLabel, Select, MenuItem, Snackbar, Alert , Autocomplete , Paper, 
} from "@mui/material";
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import CircularProgress from "@mui/material/CircularProgress";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Register = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    dob: "",
    mobile: "",
    city: "",
    district: "",
    state: "",
    pincode: "",
    identityProofType: "", 
    identityProofNumber: "",
    panCard: " ",
    panCardNumber: "",
  });
  const [errors, setErrors] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);


  const validateForm = () => {
    let newErrors = {};

    if (!formData.firstName.trim()) {
      newErrors.firstName = "First Name is required";
    }
    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last Name is required";
    }
    if (!formData.dob.trim()) {
      newErrors.dob = "Date of Birth is required";
    } else {
      const selectedDate = new Date(formData.dob);
      const today = new Date();
      const minDate = new Date("1900-01-01");

      const minAllowedDate = new Date();
      minAllowedDate.setFullYear(today.getFullYear() - 18);

      // Remove time part for accurate date comparison
      today.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);
      minDate.setHours(0, 0, 0, 0);
      minAllowedDate.setHours(0, 0, 0, 0);

      if (selectedDate >= today) {
        newErrors.dob = "Date of Birth must be in the past";
      } else if (selectedDate < minDate) {
        newErrors.dob = "Date of Birth must be after 01-01-1900";
      } else if (selectedDate > minAllowedDate) {
        newErrors.dob = "Minimum age required to register is 18 years.";
      }
    }
    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile Number is required";
    } else if (formData.mobile.length !== 10) {
      newErrors.mobile = "Mobile number must be exactly 10 digits";
    }
    if (!formData.city.trim()) {
      newErrors.city = "City is required";
    }
    if (!formData.district.trim()) {
      newErrors.district = "District is required";
    }
    if (!formData.state.trim()) {
      newErrors.state = "State is required";
    }
    if (!formData.pincode.trim()) {
      newErrors.pincode = "Pincode is required";
    } else if (formData.pincode.length !== 6) {
      newErrors.pincode = "Pincode must be exactly 6 digits";
    }
    // Validate PAN Number
    // if (formData.panCardNumber && !/^[A-Z]{5}\d{4}[A-Z]{1}$/.test(formData.panCardNumber)) {
    //   return;
    // }

    // if (formData.identityProofType === "aadhaar" && formData.identityProofNumber.length !== 12) {
    //   return;
    // }

    // if (formData.identityProofType === "license" && !/^[A-Z]{2}\d{13}$/.test(formData.identityProofNumber)) {
    //   return;
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  // Handles radio button changes
  const handleRadioChange = (e) => {
    const selectedType = e.target.value;

    setFormData((prev) => ({
      ...prev,
      identityProofType: selectedType,
      
    }));
  };
  const handlePanChange = (e) => {
    const value = e.target.value;
    setFormData({ ...formData, panCard: e.target.value, panCardNumber: e.target.value === "No" ? "" : formData.panCardNumber });

  };
  const requestBody = {
    method: "post",  
    ...formData,  
  };


  const [openSnackbar, setOpenSnackbar] = useState(false);
  const navigate = useNavigate();

  const districts = ["Ariyalur", "Chengalpattu", "Chennai", "Coimbatore", "Cuddalore", "Dharmapuri",
    "Dindigul", "Erode", "Kallakurichi", "Kancheepuram", "Kanyakumari", "Karur", "Karaikal", "Krishnagiri",
    "Madurai", "Mayiladuthurai", "Nagapattinam", "Namakkal", "Nilgiris", "Perambalur", "Pudukkottai",
    "Ramanathapuram", "Ranipet", "Salem", "Sivaganga", "Tenkasi", "Thanjavur", "Theni", "Thoothukudi",
    "Thiruchirappalli", "Tirunelveli", "Tirupathur", "Tiruppur", "Tiruvallur", "Tiruvannamalai", "Tiruvarur",
    "Vellore", "Viluppuram", "Virudhunagar", "Other"
  ];
  const states = ["Tamil Nadu", "Other"];
  


  const handleChange = (e) => {

    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (e) => {
    console.log("OnSubmit Function");
    console.log(requestBody);

    e.preventDefault();
    setIsLoading(true);
    setIsSubmitted(true);

    if (!validateForm()) {
      setIsLoading(false);

      return;
    }



    try {
      // eslint-disable-next-line 
      const response = await fetch(
        API_BASE_URL,
        {
          method: "POST",
          mode: "cors", 
          // headers: {
          //      "Content-Type": "application/json",
          // },
          body: JSON.stringify(requestBody),
        }
      );
      setIsLoading(false);

      const result = await response.json();

      if (result.status === "error") {
        setSnackbarMessage(result.message); 
        setSnackbarOpen(true);

        return;
      }

      console.log("Data sent successfully")
      setOpenSnackbar(true);

      // Clear the form after submission
      setFormData({
        firstName: "",
        lastName: "",
        dob: "",
        mobile: "",
        city: "",
        district: "",
        state: "",
        pincode: "",
        identityProofType: "",
        identityProofNumber: "",
        panCard: "",
        panCardNumber: "",
      });

      // Redirect after success
      setTimeout(() => {
        navigate("/login");
        window.scrollTo(0, 0);
      }, 2000);
    } catch (error) {
      console.error("Error sending data:", error);
      setSnackbarMessage("Something went wrong!");
      setSnackbarOpen(true);
      alert("Failed to send data");
      setIsLoading(false);
    }
  };

  const handleClear = () => {
    setFormData({
      firstName: "",
      lastName: "",
      dob: "",
      mobile: "",
      city: "",
      district: "",
      state: "",
      pincode: "",
      identityProofType: "", 
      identityProofNumber: "",
      panCard: "",
      panCardNumber: "",
    });
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };



  return (
    <Box sx={{ backgroundColor: "#f8f9e9", py: 6, top: "150px", bottom: "150px" }}>
      <Container>
        <Typography variant="h3" sx={{ fontWeight: "500", color: "#2A289C", textAlign: "center", fontSize: "32px" }}>
          New Member Registration 
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: "300", color: "#7A7841", my: 2, fontSize: "16px", textAlign: "center" }}>
          Please provide your basic details to set up your account.
          Once logged in,<br></br> you'll be able to complete your profile and proceed with membership activation.
        </Typography>


        <form onSubmit={handleSubmit}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault(); 
              handleSubmit(e);
            }
          }}>
          <Grid item xs={12} md={6}>
            <Box
              component="form"
              sx={{
                backgroundColor: "#f8f9e9",
             padding: 4,
             borderRadius: "8px",
             border: "1px solid #CEC35E",
             boxShadow: 1,
             borderColors: "#CEC35E",
             boxShadow: 3,
             width: "80%",
              maxWidth: "900px",
              margin: "0 auto",
              }}
            >


            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                <TextField fullWidth size="small" label="First Name" placeholder="First Name" name="firstName" value={formData.firstName} onChange={handleChange} inputProps={{ maxLength: 25, pattern: "[A-Za-z]*" }}
                  onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
                  sx={{ mb: 2 }}
                  error={!!errors.firstName}
                  helperText={errors.firstName || ""}
                  required
                />

                <TextField fullWidth size="small" label="Last Name" placeholder="Last Name" name="lastName" value={formData.lastName} onChange={handleChange} inputProps={{ maxLength: 25, pattern: "[A-Za-z]*" }}
                  onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
                  sx={{ mb: 2 }}
                  error={!!errors.lastName}
                  helperText={errors.lastName || ""}
                  required
                />


                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Date of Birth"
                    format="DD-MM-YYYY"
                    value={formData.dob ? dayjs(formData.dob, "YYYY-MM-DD") : null}
                    onChange={(date) => setFormData({ ...formData, dob: date ? date.format("YYYY-MM-DD") : "" })}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        error: !!errors.dob,
                        helperText: errors.dob || "",
                        required: true,
                      },
                      popper: {
                        sx: {
                          '& .MuiPaper-root': {
                            backgroundColor: '#f8f9e9', 
                          },
                        },
                      },
                    
                    }}
                    disableFuture
                    maxDate={dayjs().subtract(18, "year")}
                   
                  />
                </LocalizationProvider>

                <TextField fullWidth size="small" label="Mobile Number" placeholder="Mobile Number" type="text" name="mobile" value={formData.mobile}

                  onChange={(e) => {
                    const inputValue = e.target.value.replace(/\D/g, ""); if (inputValue.length <= 10) {
                      setFormData({ ...formData, mobile: inputValue });
                    }
                  }}
                  error={!!errors.mobile}
                  helperText={errors.mobile || " "}
                  required
                />



                <TextField fullWidth size="small" label="City" placeholder="City" name="city" value={formData.city} onChange={handleChange} inputProps={{ maxLength: 30, pattern: "[A-Za-z]*" }}
                  onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
                  sx={{ mb: 2 }}
                  error={!!errors.city}
                  helperText={errors.city || ""}
                  required
                />


                  <Autocomplete
                    options={districts}
                    value={formData.district}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        setFormData({ ...formData, district: newValue });
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="District"
                        variant="outlined"
                        size="small"
                        required
                        error={!!errors.district}
                        helperText={errors.district || ""}
                        sx={{
                          backgroundColor: "#f8f9e9",
                          mb: 2,
                          "& .MuiInputBase-input": {
                            caretColor: "transparent", 
                            cursor: "pointer", 
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                          sx: {
                            backgroundColor: "#f8f9e9",
                            px: 1,
                            transform: "translate(14px, -6px) scale(0.75)",
                          },
                        }}
                        InputProps={{
                          ...params.InputProps,
                          readOnly: false, 
                        }}
                      />
                    )}
                    disableClearable
                    fullWidth
                    autoHighlight
                    PaperComponent={(props) => (
                      <Paper
                        {...props}
                        sx={{
                          backgroundColor: "#f8f9e9", 
                        }}
                      />
                    )}
                  />



                <Autocomplete
                  options={states}
                  value={formData.state}
                  onChange={(event, newValue) => {
                    if (newValue) {
                      setFormData({ ...formData, state: newValue });
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="State"
                      variant="outlined"
                      size="small"
                      required
                      error={!!errors.state}
                      helperText={errors.state || ""}
                      sx={{
                        backgroundColor: "#f8f9e9",
                        mb: 2,
                        "& .MuiInputBase-input": {
                          caretColor: "transparent",  
                          cursor: "pointer",          
                        },
                      }}
                      InputLabelProps={{
                        shrink: true,
                        sx: {
                          backgroundColor: "#f8f9e9",
                          px: 1,
                          transform: "translate(14px, -6px) scale(0.75)",
                        },
                      }}
                      InputProps={{
                        ...params.InputProps,
                        readOnly: false,
                      }}
                    />
                  )}
                  disableClearable
                  fullWidth
                  autoHighlight

                  PaperComponent={(props) => (
                    <Paper
                      {...props}
                      sx={{
                        backgroundColor: "#f8f9e9", 
                      }}
                    />
                  )}
                />
                
                <TextField
                  fullWidth size="small"
                  label="Pincode"
                  placeholder="Pincode"
                  type="text"
                  name="pincode"

                  value={formData.pincode}
                  onChange={(e) => {
                    const inputValue = e.target.value.replace(/\D/g, "");
                    if (inputValue.length <= 6) {
                      setFormData({ ...formData, pincode: inputValue });
                    }
                  }}
                  error={!!errors.pincode}
                  helperText={errors.pincode || ""}
                  sx={{ mb: 2 }}
                  required

                />



                <Box sx={{ backgroundColor: "#f8f9e9", p: 2 }}>
                  <Grid container spacing={2} alignItems="center">
                    {/* ID Proof Label & Radio Buttons in One Row */}
                    <Grid item xs={2}>
                      <FormLabel sx={{ whiteSpace: "nowrap" }} >ID Proof  </FormLabel>
                    </Grid>
                    <Grid item xs={12} sm={10}>
                      <FormControl component="fieldset" >
                        <RadioGroup row name="identityProofType" value={formData.identityProofType} onChange={handleRadioChange}>
                          <FormControlLabel value="aadhaar" control={<Radio sx={{ color: "gray" }} />} label="Aadhaar" />
                          <FormControlLabel value="license" control={<Radio sx={{ color: "grey" }} />} label="License" />

                        </RadioGroup>
                      </FormControl>
                    </Grid>

                    {/* Aadhar Number Field */}
                    {formData.identityProofType === "aadhaar" && (
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          size="small"
                          label="Aadhaar Number"
                          type="text"
                          name="identityProofNumber"
                          value={formData.identityProofNumber}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "").slice(0, 12); // Keep only numbers
                            setFormData((prev) => ({ ...prev, identityProofNumber: value }));
                          }}
                          error={isSubmitted && (!formData.identityProofNumber || formData.identityProofNumber.length !== 12)}
                          helperText={
                            isSubmitted && (
                              !formData.identityProofNumber
                                ? " "
                                : formData.identityProofNumber.length !== 12
                                ? " "
                                : ""
                            )
                          }
                          placeholder="Enter Aadhaar Number"
          
                        />
                      </Grid>
                    )}


                    {/* License Number Field */}
                    {formData.identityProofType === "license" && (
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          size="small"
                          label="License Number"
                          type="text"
                          name="identityProofNumber"
                          value={formData.identityProofNumber}
                          onChange={handleChange}
                          error={
                            isSubmitted &&
                            (!formData.identityProofNumber
                              ? true
                              : !/^[A-Z]{2}\d{13}$/.test(formData.identityProofNumber))
                          }
                          helperText={
                            isSubmitted &&
                            (!formData.identityProofNumber
                              ? " "
                              : !/^[A-Z]{2}\d{13}$/.test(formData.identityProofNumber)
                              ? " "
                              : "")
                          }
                          inputProps={{ maxLength: 15 }}
                          placeholder="Enter License Number"
                          onInput={(e) =>
                            (e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 15))
                          }
                          

                        />
                      </Grid>
                    )}



                  </Grid>
                </Box>
                {/* PAN Requirement Selection */}
                <Box sx={{ backgroundColor: "#f8f9e9", p: 2 }}>
                  <Grid container spacing={2} alignItems="center">

                    {/* PAN Number Label */}
                    <Grid item xs={2}>
                      <FormLabel sx={{ whiteSpace: "nowrap" }} >PAN Card </FormLabel>
                    </Grid>

                    {/* PAN Required Radio Buttons */}
                    <Grid item xs={12} sm={10} >
                      <FormControl component="fieldset" style={{ marginRight: 64 }}>
                        <RadioGroup row name="panCard" value={formData.panCard} onChange={handlePanChange}>
                          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="No" control={<Radio />} label="No" />

                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Box sx={{ backgroundColor: "#f8f9e9", mt: 2 }}>
                    {/* PAN Number Field (Only if "Yes" is selected) */}
                    {formData.panCard === "Yes" && (


                  <Grid item xs={12} sx={{ mt: 2 }}>
                        <TextField
                          fullWidth
                          size="small"
                          label="PAN Number"
                          placeholder="Enter PAN Number"
                          name="panCardNumber"
                          value={formData.panCardNumber}
                          onChange={handleChange}
                          error={
                            isSubmitted &&
                            (!formData.panCardNumber
                              ? true
                              : !/^[A-Z]{5}\d{4}[A-Z]{1}$/.test(formData.panCardNumber))
                          }
                          helperText={
                            isSubmitted &&
                            (!formData.panCardNumber
                              ? " "
                              : !/^[A-Z]{5}\d{4}[A-Z]{1}$/.test(formData.panCardNumber)
                              ? " "
                              : "")
                          }
                          inputProps={{ maxLength: 10 }}
                          
                          onInput={(e) =>
                            (e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 10))
                          }
                          

                        />
                      </Grid>


                    )}
                  </Box>
                </Box>
              </div>
            </Box>
            {/* Buttons */}
            <Grid container spacing={2} justifyContent="center" sx={{ mt: 2 }}>
              <Grid item>
                {isLoading ? (
                  <CircularProgress color="success" />
                ) : (
                  <Button type="submit"
                    onSubmit={handleSubmit}
                    variant="contained"
                    disabled={isLoading}

                    fullWidth style={{ backgroundColor: "green", color: "white" }}>

                    Register
                  </Button>
                )}
              </Grid>
              <Grid item >
                <Button variant="contained" fullWidth style={{ backgroundColor: "#6C757D", color: "white" }} onClick={handleClear}>
                  Clear
                </Button>
              </Grid>
              <Grid item>
                <Button variant="contained" fullWidth style={{ backgroundColor: "#E52029", color: "white" }} onClick={() => {
                  navigate("/");
                  window.scrollTo(0, 0);
                }}>
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Container>
      {/* Snackbar Alert */}
      <Snackbar open={openSnackbar} autoHideDuration={3000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: "top", horizontal: "right" }}  >
        <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: "100%", fontSize: "16px", fontWeight: "bold" }}>
          Member Created Successfully!
        </Alert>
      </Snackbar>
      <Snackbar open={snackbarOpen} autoHideDuration={10000} onClose={() => setSnackbarOpen(false)} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <Alert onClose={() => setSnackbarOpen(false)} severity="error" sx={{ width: "100%", fontSize: "16px", fontWeight: "bold" }}>{snackbarMessage}</Alert></Snackbar>

       
        
        
    </Box>

  );
}

export default Register;